import React, { useState } from 'react';
import Popup from 'reactjs-popup';
import axios from 'axios';

const ModalModifyServeur = ({ isVisible, onClose, choosenClient }) => {
    
    let token = localStorage.getItem("token");
    const [values, setValues] = useState({
        id: '',
        nom_serveur: '',
        url_serveur: '',
        version_serveur: '',   
    })

    const handleClose = (e) => {
        if (e.target.id === "wrapper") onClose();
    }

    if (choosenClient.id !== values.id) setValues({ ...values, ...choosenClient })

    const headers = {
        'x-access-token': token,
        'Content-Type': 'application/json'
    };
    const deleteClient = (e) => {
        e.preventDefault();
        let data = {
            id: values.id
        }
        axios.delete(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/delete_serveur`,{headers, data})
        .then((res) => {
                console.log(res);
                window.location.reload(false);
            }).catch(err => console.log(err))
        
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        let error = document.getElementById('error');
        error.innerHTML = '';
        if(values.nom_serveur === '' || values.url_serveur === '' || values.version_serveur === ''){
            error.innerHTML = "Veuillez renseigner tout les champs"
        }else{
            axios.post(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/update_serveur`, values)
            .then(res => {
                console.log(res);
                window.location.reload(false);
            }).catch(err => console.log(err))
        }
    }


    const close = () => {
        let divTooltip = document.getElementById('popup-2');
        divTooltip.style.display = "none"
    }
    
    if (!isVisible) return null;
    return (
        <div className='fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4' id="wrapper" onClick={handleClose}>
            <div className='bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[85vh] overflow-y-auto'>
                <div className="flex items-center justify-between border-b border-slate-200 px-6 py-4">
                    <h2 className="text-lg font-semibold text-slate-800">Modifier le serveur</h2>
                    <button type="button" className='flex h-8 w-8 items-center justify-center rounded-lg text-slate-400 hover:bg-slate-100 hover:text-slate-600' onClick={() => onClose()}>✕</button>
                </div>
                <form className="p-6" onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label htmlFor="nom_serveur" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Nom serveur</label>
                        <input type="text" name="nom_serveur" id="nom_serveur" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder="Nom serveur" required onChange={e => setValues({ ...values, nom_serveur: e.target.value })} value={values.nom_serveur} />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="url_serveur" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">URL serveur</label>
                        <input type="text" name="url_serveur" id="url_serveur" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder="URL serveur" required onChange={e => setValues({ ...values, url_serveur: e.target.value })} value={values.url_serveur} />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="version_serveur" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Version serveur</label>
                        <input type="text" name="version_serveur" id="version_serveur" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder="Version serveur" required onChange={e => setValues({ ...values, version_serveur: e.target.value })} value={values.version_serveur} />
                    </div>

                    <div className='flex justify-between'>
                        <button type="submit" className="rounded-lg bg-indigo-500 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-600">Enregistrer</button>
                        <Popup trigger=
                            {<button type="button" className="rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700" > Supprimer </button>}
                            position="right center">
                            <div>Est-ce votre dernier mot?</div>
                            <div className="flex justify-between gap-2 mt-2">
                                <button type="button" className="rounded-lg bg-indigo-500 px-3 py-2 text-sm font-medium text-white hover:bg-indigo-600" onClick={deleteClient}> Accepter </button>
                                <button type="button" className="rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50" onClick={close}> Annuler </button>
                            </div>
                        </Popup>
                    </div>
                    <div className="py-4 text-center">
                        <p id="error" className='text-red-600'></p>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ModalModifyServeur;